import { Alert } from '@mui/material'
import React from 'react'

const EmailVerificationPasswordSent = () => {
  return (
    <div style={{height: '100vh'}}>
      <Alert severity="success" style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h3>A link for resetting the password has been sent to your email</h3>
      </Alert>
    </div>

  )
}

export default EmailVerificationPasswordSent